@if (!isIframe && (authorizationService.isLoginInProgress$ | async) === false && (displayPage$ | async) == true && authorizationService.isPressureSensorLoaded()) {
    @if ((authorizationService.hasPermissions$ | async) === false) {
        <router-outlet />
    }
    @if ((authorizationService.hasPermissions$ | async) === true) {
        @if (isPageMissing === false) {
            <app-portal-header></app-portal-header>
        }
        @if (authorizationService.hasAnyPressureSensor() || isSettingPage) {
            <router-outlet />
        } @else {
            <div class="content text-center">
                <div class="d-flex flex-column justify-content-center content-height default-icon-color align-items-center">
                    <i class="fas fa-info-circle fa-7x"></i>
                    <div class="no-records-message">{{ 'pressureMonitoring.notFound.pressureSensor.title' | translation | async }}</div>
                    <div class="no-records-message-detail">
                        {{ 'pressureMonitoring.notFound.pressureSensor.detail' | translation | async }}
                        <div class="mt-3">
                            <button class="btn btn-primary" (click)="viewAssets()">{{ 'pressureMonitoring.notFound.pressureSensor.actionButton' | translation | async }}</button>
                        </div>
                    </div>
                </div>
            </div>
        }
    }
} @else {
    @if ((authorizationService.isLoginInProgress$ | async) === false && (isTenantMissing || (isPageMissing && isTenantMissing == false))) {
        <router-outlet />
    }
}
